"use client";

import { logEvent } from 'firebase/analytics';
import { analytics } from '@/lib/firebase/clientApp';
import {
  ANALYTICS_EVENTS,
  AnalyticsEventName,
  PageViewParams,
  EventParams,
} from '@/lib/firebase/constants/analytics';

/**
 * Firebase Analytics 서비스 레이어
 * 모든 분석 이벤트를 중앙에서 관리
 */
export class AnalyticsService {
  /**
   * 페이지 뷰 추적
   */
  static trackPageView(params: PageViewParams) {
    if (!analytics) return;

    logEvent(analytics, ANALYTICS_EVENTS.PAGE_VIEW, {
      page_title: params.page_title,
      page_location: params.page_location,
      page_path: params.page_path,
    });

    if (process.env.NODE_ENV === 'development') {
      console.log('[Analytics] Page View:', params.page_path);
    }
  }

  /**
   * 범용 이벤트 추적
   */
  static trackEvent(eventName: AnalyticsEventName, params?: EventParams) {
    if (!analytics) return;

    // Firebase logEvent는 커스텀 이벤트명을 string으로 받음
    logEvent(analytics, eventName as string, params);

    if (process.env.NODE_ENV === 'development') {
      console.log('[Analytics] Event:', eventName, params);
    }
  }

  // 편의 메서드들
  static trackLogin(method: string = 'google') {
    this.trackEvent(ANALYTICS_EVENTS.LOGIN, { method });
  }

  static trackSignUp(method: string = 'google') {
    this.trackEvent(ANALYTICS_EVENTS.SIGN_UP, { method });
  }

  static trackProjectUpload(projectId?: string) {
    this.trackEvent(ANALYTICS_EVENTS.PROJECT_UPLOAD, { project_id: projectId });
  }

  static trackProjectDownload(projectId: string, fileType: string) {
    this.trackEvent(ANALYTICS_EVENTS.PROJECT_DOWNLOAD, { project_id: projectId, file_type: fileType });
  }

  static trackTrialStart() {
    this.trackEvent(ANALYTICS_EVENTS.TRIAL_START);
  }

  static trackPlanRequest(currentPlan: string, requestedPlan: string) {
    this.trackEvent(ANALYTICS_EVENTS.PLAN_REQUEST, { current_plan: currentPlan, requested_plan: requestedPlan });
  }

  static trackButtonClick(buttonName: string, location?: string) {
    this.trackEvent(ANALYTICS_EVENTS.BUTTON_CLICK, { button_name: buttonName, location });
  }
}
